/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../hooks/useSendTelemetry';
import { GoToText } from '../../../components/Texts/GoToText';
import { GoToErrorHeading } from '../../../components/Headings/GoToErrorHeading';

const messages = defineMessages({
  heading: {
    id: 'goto.error.e2ee.heading',
  },
  troubleshootingInstructions: {
    id: 'goto.error.e2ee.troubleshooting',
  },
});

export const EndToEndEncryptionError: React.FC = () => {
  const { formatMessage: f } = useIntl();
  const sendTelemetry = useSendTelemetry();

  useEffect(() => {
    sendTelemetry(
      TelemetryComponent.Web,
      TelemetryAction.Fail,
      TelemetryState.Error
    );
  });

  return (
    <>
      <GoToErrorHeading>{f(messages.heading)}</GoToErrorHeading>
      <GoToText>{f(messages.troubleshootingInstructions)}</GoToText>
    </>
  );
};
